// import React, { useState, useEffect } from 'react';
// import '../styles/testimonials.scss'; 
// import TestimonialImage from "../assets/banner/banner10.webp";
// import { serverUrl } from '../serverUrl';
// import { FaStar, FaStarHalfAlt, FaRegStar } from 'react-icons/fa';

// const TestimonialSection = () => {
//   const [activeIndex, setActiveIndex] = useState(0);
//   const [testimonials, setTestimonials] = useState([]);
//   const [displayTestimonials, setDisplayTestimonials] = useState([]);

//   // Dummy testimonials to show when backend returns empty
//   const dummyTestimonials = [
//     {
//       id: 'dummy-1',
//       score: 5,
//       review: "The craftsmanship was absolutely outstanding! My custom bookshelf exceeded all expectations.",
//       client_name: "Sarah Johnson",
//       isDummy: true
//     },
//     {
//       id: 'dummy-2',
//       score: 4.5,
//       review: "Professional service from start to finish. The artisan understood exactly what I wanted and delivered perfectly.",
//       client_name: "Michael Chen",
//       isDummy: true
//     },
//     {
//       id: 'dummy-3',
//       score: 4,
//       review: "Great attention to detail and very communicative throughout the project. Highly recommended!",
//       client_name: "Emma Wilson",
//       isDummy: true
//     }
//   ];

//   useEffect(() => {
//     fetchTestimonials();
//   }, []);

//   useEffect(() => {
//     // Use real testimonials if available, otherwise use dummies
//     if (testimonials.length > 0) {
//       setDisplayTestimonials(testimonials);
//       setActiveIndex(0);
//     } else {
//       setDisplayTestimonials(dummyTestimonials);
//       setActiveIndex(0);
//     }
//   }, [testimonials]);

//   const fetchTestimonials = async () => {
//     try {
//       const response = await serverUrl.get('reviews/testimonials/');
//       setTestimonials(response.data);
//       console.log("Testimonials data:", response.data);
//     } catch (error) {
//       console.error("Error fetching testimonials:", error);
//       // If error, show dummy testimonials
//       setDisplayTestimonials(dummyTestimonials);
//     }
//   };

// // Function to convert text to proper title case
// const toTitleCase = (text) => {
//   if (!text || typeof text !== 'string') return '';
  
//   const words = text.toLowerCase().split(' ');
  
//   return words
//     .map((word, index) => {
//       // Always capitalize "I" when it appears alone
//       if (word === 'i') {
//         return 'I';
//       }
      
//       // Always capitalize the first word
//       if (index === 0) {
//         return word.charAt(0).toUpperCase() + word.slice(1);
//       }
      
//       // Skip capitalizing very short common words (conjunctions, prepositions)
//       const smallWords = ['a', 'an', 'the', 'and', 'but', 'or', 'for', 'nor', 'on', 'at', 'to', 'by', 'in', 'of', 'as'];
//       if (smallWords.includes(word)) {
//         return word;
//       }
      
//       // Capitalize all other words
//       return word.charAt(0).toUpperCase() + word.slice(1);
//     })
//     .join(' ');
// };

//   // Function to properly format client names (preserve initials if any)
//   const formatClientName = (name) => {
//     if (!name || typeof name !== 'string') return 'Anonymous';
    
//     // For dummy testimonials, keep the formatted names as they are
//     if (name.includes('Dummy')) {
//       return name;
//     }
    
//     // Check if name contains acronyms or initials like "STEPHEN MAINA CLIENT"
//     const words = name.split(' ');
    
//     return words
//       .map(word => {
//         // If word is all caps and more than 1 letter, treat it as acronym
//         if (word === word.toUpperCase() && word.length > 1) {
//           // Convert to proper case for acronyms
//           return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
//         }
//         // Otherwise apply normal camel case
//         return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
//       })
//       .join(' ');
//   };

//   // Auto-rotate testimonials
//   useEffect(() => {
//     if (displayTestimonials.length === 0) return;
    
//     const interval = setInterval(() => {
//       setActiveIndex((prevIndex) => 
//         prevIndex === displayTestimonials.length - 1 ? 0 : prevIndex + 1
//       );
//     }, 5000);
    
//     return () => clearInterval(interval);
//   }, [displayTestimonials.length]);

//   // Function to render star rating
//   const renderStars = (score) => {
//     const stars = [];
//     const fullStars = Math.floor(score);
//     const hasHalfStar = score % 1 >= 0.5;
    
//     // Full stars
//     for (let i = 0; i < fullStars; i++) {
//       stars.push(<FaStar key={`full-${i}`} className="star-icon full" />);
//     }
    
//     // Half star
//     if (hasHalfStar) {
//       stars.push(<FaStarHalfAlt key="half" className="star-icon half" />);
//     }
    
//     // Empty stars
//     const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
//     for (let i = 0; i < emptyStars; i++) {
//       stars.push(<FaRegStar key={`empty-${i}`} className="star-icon empty" />);
//     }
    
//     return stars;
//   };

//   return (
//     <section className="testimonial-section">
//       <div className="container">
//         <div className="testimonial-wrapper">
//           {/* Left Side: Static Image */}
//           <div className="testimonial-image-side">
//             <div className="image-container">
//               <img 
//                 src={TestimonialImage} 
//                 alt="Happy clients" 
//                 className="testimonial-image"
//               />
//             </div>
//           </div>

//           {/* Right Side: Testimonials */}
//           <div className="testimonial-content-side">
//             <h2 className="section-title">Clients Testimonial</h2>
            
//             {/* Dummy indicator badge - only show when using dummy testimonials */}
         
            
//             <div className="testimonial-carousel">
//               {displayTestimonials.length > 0 ? (
//                 <>
//                   {/* Active testimonial */}
//                   <div className="testimonial-card active">
//                     <div className="stars-rating">
//                       {renderStars(displayTestimonials[activeIndex]?.score || 0)}
//                       <span className="rating-score">
//                         {displayTestimonials[activeIndex]?.score || 0}/5
//                       </span>
//                     </div>
//                     <p className="testimonial-text">
//                       "{toTitleCase(displayTestimonials[activeIndex]?.review) || 'No review available'}"
//                     </p>
//                     <div className="testimonial-author">
//                       <h5 className="testimonial-name">
//                         {formatClientName(displayTestimonials[activeIndex]?.client_name) || 'Anonymous'}
//                       </h5>
                      
//                     </div>
//                   </div>
                  
//                   {/* Carousel Controls */}
//                   {/* {displayTestimonials.length > 1 && (
//                     <div className="carousel-controls">
//                       <button 
//                         className="carousel-btn prev"
//                         onClick={() => setActiveIndex(prev => 
//                           prev === 0 ? displayTestimonials.length - 1 : prev - 1
//                         )}
//                       >
//                         <i className="bi bi-chevron-left"></i>
//                       </button>
                      
//                       <div className="carousel-indicators">
//                         {displayTestimonials.map((_, index) => (
//                           <button
//                             key={index}
//                             className={`indicator ${index === activeIndex ? 'active' : ''}`}
//                             onClick={() => setActiveIndex(index)}
//                           />
//                         ))}
//                       </div>
                      
//                       <button 
//                         className="carousel-btn next"
//                         onClick={() => setActiveIndex(prev => 
//                           prev === displayTestimonials.length - 1 ? 0 : prev + 1
//                         )}
//                       >
//                         <i className="bi bi-chevron-right"></i>
//                       </button>
//                     </div>
//                   )} */}
//                 </>
//               ) : (
//                 <div className="testimonial-card active">
//                   <div className="stars-rating">
//                     {renderStars(5)}
//                     <span className="rating-score">5/5</span>
//                   </div>
//                   <p className="testimonial-text">
//                     "Loading testimonials..."
//                   </p>
//                   <div className="testimonial-author">
//                     <h5 className="testimonial-name">
//                       ArtisanHub
//                     </h5>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default TestimonialSection;



// src/components/TestimonialSection.jsx
import React, { useState, useEffect } from 'react';
import '../styles/testimonials.scss';
import TestimonialImage from '../assets/banner/banner10.webp';
import { serverUrl } from '../serverUrl';
import {
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
  FaQuoteLeft,
  FaChevronLeft,
  FaChevronRight,
} from 'react-icons/fa';

// Fallback testimonials when the API returns nothing
const DUMMY_TESTIMONIALS = [
  {
    id: 'dummy-1',
    score: 5,
    review:
      'The craftsmanship was absolutely outstanding. My custom bookshelf exceeded every expectation I had — the finish, the joinery, everything.',
    client_name: 'Sarah Johnson',
    isDummy: true,
  },
  {
    id: 'dummy-2',
    score: 4.5,
    review:
      'Professional service from start to finish. The artisan understood exactly what I wanted and delivered it perfectly, on schedule.',
    client_name: 'Michael Chen',
    isDummy: true,
  },
  {
    id: 'dummy-3',
    score: 4,
    review:
      'Great attention to detail and very communicative throughout the project. I was updated with photos at every milestone.',
    client_name: 'Emma Wilson',
    isDummy: true,
  },
];

const TestimonialSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [testimonials, setTestimonials] = useState([]);
  const [displayTestimonials, setDisplayTestimonials] = useState([]);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  useEffect(() => {
    if (testimonials.length > 0) {
      setDisplayTestimonials(testimonials);
      setActiveIndex(0);
    } else {
      setDisplayTestimonials(DUMMY_TESTIMONIALS);
      setActiveIndex(0);
    }
  }, [testimonials]);

  const fetchTestimonials = async () => {
    try {
      const response = await serverUrl.get('reviews/testimonials/');
      setTestimonials(response.data);
    } catch (error) {
      console.error('Error fetching testimonials:', error);
      setDisplayTestimonials(DUMMY_TESTIMONIALS);
    }
  };

  // ---- Title-case helper (kept from original) ----
  const toTitleCase = (text) => {
    if (!text || typeof text !== 'string') return '';
    const words = text.toLowerCase().split(' ');
    return words
      .map((word, index) => {
        if (word === 'i') return 'I';
        if (index === 0) return word.charAt(0).toUpperCase() + word.slice(1);
        const smallWords = [
          'a','an','the','and','but','or','for','nor','on','at','to','by','in','of','as',
        ];
        if (smallWords.includes(word)) return word;
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  };

  // ---- Name formatter (kept from original) ----
  const formatClientName = (name) => {
    if (!name || typeof name !== 'string') return 'Anonymous';
    if (name.includes('Dummy')) return name;
    return name
      .split(' ')
      .map((word) => {
        if (word === word.toUpperCase() && word.length > 1) {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(' ');
  };

  // ---- Auto-rotate ----
  useEffect(() => {
    if (displayTestimonials.length <= 1) return;
    const interval = setInterval(() => {
      setActiveIndex((prev) =>
        prev === displayTestimonials.length - 1 ? 0 : prev + 1,
      );
    }, 5000);
    return () => clearInterval(interval);
  }, [displayTestimonials.length]);

  const goPrev = () =>
    setActiveIndex((prev) =>
      prev === 0 ? displayTestimonials.length - 1 : prev - 1,
    );

  const goNext = () =>
    setActiveIndex((prev) =>
      prev === displayTestimonials.length - 1 ? 0 : prev + 1,
    );

  // ---- Stars ----
  const renderStars = (score) => {
    const stars = [];
    const fullStars = Math.floor(score);
    const hasHalfStar = score % 1 >= 0.5;
    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`full-${i}`} className="star-icon full" />);
    }
    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half" className="star-icon half" />);
    }
    const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<FaRegStar key={`empty-${i}`} className="star-icon empty" />);
    }
    return stars;
  };

  const current = displayTestimonials[activeIndex];

  return (
    <section className="testimonial-section" id="testimonials">
      <div className="testimonial-inner">

        {/* ============================================
            LEFT — image column
           ============================================ */}
        <div className="testimonial-visual">
          <div className="testimonial-image-frame">
            <img src={TestimonialImage} alt="Happy clients" />
          </div>

          {/* Floating rating badge */}
          <div className="testimonial-badge">
            <span className="testimonial-badge-value">4.8★</span>
            <span className="testimonial-badge-label">
              from 1,200+ happy clients
            </span>
          </div>

          {/* Decorative ring behind the image */}
          <span className="testimonial-ring" />
        </div>

        {/* ============================================
            RIGHT — content column
           ============================================ */}
        <div className="testimonial-content">
          <span className="testimonial-eyebrow">What clients say</span>

          <h2 className="testimonial-title">
            Real stories,
            <br />
            real <em>craft</em>.
          </h2>

          <p className="testimonial-sub">
            Every piece on Artiza is the result of a real collaboration
            between a client and an artisan. Here's what some of them say.
          </p>

          {/* ---------- Active testimonial ---------- */}
          <div className="testimonial-card">
            <FaQuoteLeft className="testimonial-quote-icon" />

            <div className="testimonial-stars">
              {renderStars(current?.score || 0)}
              <span className="testimonial-score">
                {current?.score || 0}/5
              </span>
            </div>

            {current?.review &&(
              <p className="testimonial-text">
              {toTitleCase(current?.review) || 'No review available'}
            </p>
            )}

            <div className="testimonial-author">
              <span className="testimonial-author-dot" />
              <span className="testimonial-author-name">
                {formatClientName(current?.client_name) || 'Anonymous'}
              </span>
            </div>
          </div>

          {/* ---------- Controls ---------- */}
          {/* {displayTestimonials.length > 1 && (
            <div className="testimonial-controls">
              <button
                type="button"
                className="testimonial-nav"
                onClick={goPrev}
                aria-label="Previous testimonial"
              >
                <FaChevronLeft />
              </button>

              <div className="testimonial-dots">
                {displayTestimonials.map((_, index) => (
                  <button
                    key={index}
                    type="button"
                    className={`testimonial-dot ${
                      index === activeIndex ? 'active' : ''
                    }`}
                    onClick={() => setActiveIndex(index)}
                    aria-label={`Go to testimonial ${index + 1}`}
                  />
                ))}
              </div>

              <button
                type="button"
                className="testimonial-nav"
                onClick={goNext}
                aria-label="Next testimonial"
              >
                <FaChevronRight />
              </button>
            </div>
          )} */}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;